"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _services = require("../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StyledGridColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  display: flex;
  justify-content: flex-end;
  & [class^='Headingstyle__Heading-sc-']{
    white-space: nowrap;
  }
`;
const UpsellTotalCost = _ref => {
  let {
    totalUpfront,
    totalRecurring
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 3
    },
    layout: {
      sm: [6, 3, 3]
    },
    spacing: 3
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    level: 4,
    weight: 3,
    text: _services.locale.localeString('RelationshipOffer.TotalCost')
  }), /*#__PURE__*/_react.default.createElement(StyledGridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    level: 4,
    weight: 3,
    text: _services.locale.formatPrice(totalUpfront)
  })), /*#__PURE__*/_react.default.createElement(StyledGridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    level: 4,
    weight: 3,
    text: _services.locale.formatPrice(totalRecurring)
  })));
};
var _default = UpsellTotalCost;
exports.default = _default;